module.exports = {"320206001":"堰桥街道","320206002":"长安街道","320206003":"钱桥街道","320206004":"前洲街道","320206005":"玉祁街道","320206102":"洛社镇","320206103":"阳山镇","320206400":"无锡惠山经济开发区","320206500":"无锡惠山工业转型集聚区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320206.json
// module id = 842
// module chunks = 0